"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLongStayDiscountFriendlyArray = void 0;
const getLongStayDiscountFriendlyArray = (discounts) => {
    const text = [];
    discounts.forEach((discount) => {
        text.push(`Discount of ${discount.discount_percentage}% for ${discount.min_nights} nights or more`);
    });
    return text;
};
exports.getLongStayDiscountFriendlyArray = getLongStayDiscountFriendlyArray;
